export default __webpack_public_path__ + "static/background_blue-be1d94f9a9830ead4d26f280fc70e0aa.png";